export { default } from './internet-check';
